export default __webpack_public_path__ + "static/media/app_store_badge.19ac4cad.svg";